import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FailedFetchError, retryOnException } from '@atlaskit/frontend-utilities/retry-operation';
import { getFullUrl } from './config';
import HttpError from './errors/HttpError';
var fetchResource = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, method) {
    var options,
      url,
      response,
      statusCode,
      text,
      httpError,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          url = getFullUrl(path);
          _context.next = 4;
          return fetch(url, _objectSpread({
            credentials: 'include',
            method: method
          }, options)).catch(function (error) {
            throw new FailedFetchError({
              error: error,
              path: path,
              method: method
            });
          });
        case 4:
          response = _context.sent;
          statusCode = response.status;
          if (response.ok) {
            _context.next = 15;
            break;
          }
          if (statusCode === 401) {
            // this.onUnauthorised();
          }
          _context.t0 = scrubTimestampFromErrorBody;
          _context.next = 11;
          return response.text();
        case 11:
          _context.t1 = _context.sent;
          text = (0, _context.t0)(_context.t1);
          httpError = new HttpError({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
          });
          throw httpError;
        case 15:
          return _context.abrupt("return", response);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchResource(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var makeJsonRquest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path, method) {
    var additionalFetchOptions,
      response,
      text,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          additionalFetchOptions = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          _context2.next = 3;
          return fetchResource(path, method, additionalFetchOptions);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return response.text();
        case 6:
          text = _context2.sent;
          return _context2.abrupt("return", text ? JSON.parse(text) : {});
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function makeJsonRquest(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
export var postResource = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path, data, retryMS, extraHeaders) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", retryOnException(function () {
            return makeJsonRquest(path, 'POST', {
              body: JSON.stringify(data),
              headers: _objectSpread({
                'content-type': 'application/json'
              }, extraHeaders)
            });
          }, {
            intervalsMS: retryMS !== null && retryMS !== void 0 ? retryMS : []
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function postResource(_x5, _x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function scrubTimestampFromErrorBody(text) {
  var json;
  try {
    json = JSON.parse(text);
  } catch (err) {
    return text;
  }
  delete json.timestamp;
  return JSON.stringify(json);
}